// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MTMIA_BxzIyTTQH7zC_y{position:absolute;top:0;left:0;width:100%;height:100%;border:1px solid #bcbfc6;pointer-events:none;z-index:999}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"borderLayer": "MTMIA_BxzIyTTQH7zC_y"
};
export default ___CSS_LOADER_EXPORT___;
